import styled from 'styled-components'

export const Container = styled.div`
  display: block;
  max-width: 600px;
  margin: auto;

  button {
    > div {
      display: flex;
      align-items: center;
    }

    svg {
      width: 18px;
      height: 18px;
      fill: ${props => props.theme.palette.general.light};
      margin: 4px 0 0 12px;
    }
  }
`

export const ShippingMethodsContainer = styled.div<any>`
  position: relative;
  ${props => props.isLoading && `
    cursor: wait;

    > div {
      pointer-events: none;
    }
  `}

  > p {
    margin: 30px 0;
  }
`
